import { useState, useEffect } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { getAgent } from '../data';
import TopNav from '../components/TopNav';
import { useTheme } from '../contexts/ThemeContext';
import './AgentLayout.css';

export default function AgentLayout() {
  const { agentId } = useParams();
  const { theme, toggleTheme } = useTheme();
  const [agent, setAgent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadAgent();
  }, [agentId]);

  const loadAgent = async () => {
    try {
      const data = await getAgent(agentId);
      setAgent(data);
    } catch (err) {
      console.error('Failed to load agent:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="agent-layout">
        <div className="agent-loading">
          <div className="loading-spinner"></div>
        </div>
      </div>
    );
  }

  if (!agent) {
    return (
      <div className="agent-layout">
        <div className="agent-not-found">Agent not found</div>
      </div>
    );
  }

  return (
    <div className="agent-layout">
      <TopNav agent={agent}>
        <button className="topnav-toggle" onClick={toggleTheme} aria-label="Toggle theme">
          {theme === 'dark' ? '○' : '●'}
        </button>
      </TopNav>

      <main className="agent-main">
        <div className="agent-main-inner">
          <div className="agent-main-content">
            <Outlet context={{ agent, setAgent, agentId }} />
          </div>
        </div>
      </main>
    </div>
  );
}
